﻿import { createApp, ref, onMounted } from 'vue';

(function ($) {
    $(function () {
        // Only run in _OrderCourseBox.cshtml
        const courseOrderBox = document.getElementById('CourseOrderBox');
        if (courseOrderBox === null) {
            return;
        }

        const app = createApp({
            setup() {
                const locations = ref([]);
                const deliveries = ref([]);
                const deliveriesToRender = ref([]);
                const selectedDeliveryId = ref(null);

                function changeLocation() {
                    const selectedLocation = $("#orderCourseBoxLocationSelect").val();

                    if (selectedLocation === "") {
                        deliveriesToRender.value = deliveries.value; // Use the outer scope variable
                    } else {
                        const newDeliveriesList = [];
                        let clearSelectedDelivery = true;

                        deliveries.value.forEach((delivery) => {
                        
                            if (delivery.location === selectedLocation) {
                                newDeliveriesList.push(delivery);

                                if (delivery.courseDeliveryId === selectedDeliveryId.value) {
                                    clearSelectedDelivery = false;
                                }
                            }
                        });

                        if (clearSelectedDelivery) {
                            selectedDeliveryId.value = newDeliveriesList.length ? newDeliveriesList[0].courseDeliveryId : null;
                        }

                        deliveriesToRender.value = newDeliveriesList;
                    }
                }

                onMounted(async () => {
                    try {
                        // Init
                        const coursePageId = courseOrderBox.dataset.coursepageid;
                        const specificLocation = courseOrderBox.dataset.specificlocation;
                        const onlyStartupGuarantee = courseOrderBox.dataset.onlystartupguarantee;

                        const url = `/api/CourseDates/${coursePageId}?onlyStartupGuarantee=${onlyStartupGuarantee}${specificLocation ? `&specificLocation=${specificLocation}` : ''}`;

                        fetch(url, { method: "GET"})
                            .then((response) => response.json())
                            .then((result) => {
                                locations.value = result.locations;
                                deliveries.value = deliveriesToRender.value = result.deliveries;
                                selectedDeliveryId.value = result.deliveries.length ? result.deliveries[0].courseDeliveryId : null;
                            });
                    } catch (error) {
                        console.error('Error fetching data:', error);
                    }
                });

                return {
                    deliveriesToRender,
                    selectedDeliveryId,
                    locations,
                    changeLocation
                };
            },
        });

        app.mount('#CourseOrderBox');

    });
})(jQuery);